import { render, staticRenderFns } from "./LowInventories.vue?vue&type=template&id=76ca7657&"
import script from "./LowInventories.vue?vue&type=script&lang=js&"
export * from "./LowInventories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports